var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Slide from '@material-ui/core/Slide';
import { messages } from "./PreviewFilesMessages";
import { useStyles } from "./PreviewFilesStyles";
import { File } from "./File";
import { Image } from "./Image";
import { Video } from "./Video";
import { Audio } from "./Audio";

const PreviewFiles = _ref => {
  let files = _ref.files,
      setFiles = _ref.setFiles;
  const intl = useIntl();
  const classes = useStyles();
  const components = {
    image: Image,
    file: File,
    video: Video,
    audio: Audio
  };

  const handleRemoveFileToSend = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (id) {
      return yield setFiles(files.filter(file => file.id !== id));
    });

    return function handleRemoveFileToSend(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return _jsx(Slide, {
    direction: "up",
    in: !!files.length,
    mountOnEnter: true,
    unmountOnExit: true
  }, void 0, _jsx("div", {
    className: classes.container
  }, void 0, files.map(file => {
    const Component = components[file.type];
    return _jsx(Component, {
      path: file.url,
      id: file.id,
      name: file.name,
      extension: file.extension,
      handleRemoveFile: handleRemoveFileToSend
    });
  })));
};

export { PreviewFiles };